import { Injectable } from '@angular/core';

const sortReservations = (a: any, b: any) =>
	a.first_name > b.first_name ? 1 : b.first_name > a.first_name ? -1 : 0;

@Injectable({ providedIn: 'root' })
export class BaseRepository {
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - groupBy
	 **-------------------------------------------------------------------------------------
	 */
	groupBy(list: any[], key: string, item: string) {
		const groupedArray = list.reduce((hash, obj) => {
			if (obj[key] === undefined) return hash;
			return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) });
		}, {});
		const keys = Object.keys(groupedArray);
		const formattedArray = [];
		keys.forEach(header => {
			formattedArray.push({
				header,
				[item]: groupedArray[header].sort(sortReservations),
			});
		});
		return formattedArray;
	}
}
